import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useLang } from "@/context/LangContext";

const PHOTOS = [
  "https://images.unsplash.com/photo-1757744705465-ea08b0ddc38a?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  "https://images.unsplash.com/photo-1581322929625-f4aab333778a?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  "https://images.unsplash.com/photo-1525457136159-8878648a7ad0?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  "https://images.unsplash.com/photo-1630939687530-241d630735df?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
];

export const Testimonials = () => {
  const { t } = useLang();
  const items = t("testimonials.items") || [];
  return (
    <section id="testimonios" data-testid="testimonials-section" className="relative py-16 md:py-28 bg-[#0d1730] ej-grain overflow-hidden">
      <div className="orb w-[380px] h-[380px] bg-[#FFD166] top-0 -left-24 opacity-10" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="bg-[#E63946]/15 text-[#FF8A8A] border border-[#E63946]/30 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
            {t("testimonials.eyebrow")}
          </span>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl mt-5 text-white leading-tight">{t("testimonials.title")}</h2>
          <p className="text-slate-300 mt-4">{t("testimonials.subtitle")}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {items.map((it, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
              className="bg-[#1C2541]/90 backdrop-blur-sm border border-white/10 rounded-3xl p-6 flex flex-col card-hover"
            >
              <Quote size={26} className="text-[#FFD166]" />
              <p className="text-slate-200 mt-4 leading-relaxed flex-1">&ldquo;{it.quote}&rdquo;</p>
              <div className="flex gap-0.5 text-[#FFD166] mt-5">
                {[...Array(5)].map((_, s) => <Star key={s} size={14} fill="currentColor" />)}
              </div>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-white/10">
                <img src={PHOTOS[i]} alt={it.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#FFD166]/40" />
                <div>
                  <div className="font-head font-bold text-white text-sm">{it.name} · <span className="text-slate-400 font-normal">{it.from}</span></div>
                  <div className="text-xs text-[#FFD166]">{it.role}</div>
                  <div className="text-[11px] text-slate-500 mt-0.5">{it.time}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
